var _path, _path2, _path3, _rect, _rect2, _path4, _path5, _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyNews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 124,
    viewBox: "0 0 182 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.565 29.5858C113.19 29.2107 112.681 29 112.151 29H88C86.8954 29 86 29.8954 86 31V85C86 86.1046 86.8954 87 88 87H128C129.105 87 130 86.1046 130 85V46.8489C130 46.3185 129.789 45.8098 129.414 45.4347L113.565 29.5858Z",
    fill: "#ECEEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113 29.0205V46H129.979L113 29.0205Z",
    fill: "#C3C8E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 56H122V59H96V56ZM96 63.5342H122V66.5342H96V63.5342ZM114 71.0684H96V74.0684H114V71.0684Z",
    fill: "#D6DAF1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 63.7998,
    width: 34,
    height: 36,
    transform: "rotate(-15 55 63.7998)",
    fill: "#C3C8E3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 58,
    width: 34,
    height: 36,
    fill: "#E4E6F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60H98V88H68V60Z",
    fill: "#F4F5F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1115_7228",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 60,
    width: 30,
    height: 28
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60H98V88H68V60Z",
    fill: "#F4F5F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1115_7228)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4829 71.8298C77.0837 71.2768 76.2602 71.2768 75.8611 71.8298L64.23 87.9464C63.7527 88.6078 64.2252 89.5316 65.0408 89.5316H79.439C78.9866 90.1734 79.4367 91.1016 80.2615 91.1016H102.021C102.896 91.1016 103.349 90.0584 102.752 89.4192L91.8723 77.7656C91.477 77.3421 90.8057 77.3421 90.4104 77.7656L85.5352 82.9875L77.4829 71.8298Z",
    fill: "#D6DAF1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 65.001,
    r: 2,
    fill: "#D6DAF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNews);
export default __webpack_public_path__ + "static/media/empty_news.016aa86e9912eaa3c63358ee880fbec9.svg";
export { ForwardRef as ReactComponent };